import { render, staticRenderFns } from "./IndexLayout.vue?vue&type=template&id=e41067d4&scoped=true&"
import script from "./IndexLayout.vue?vue&type=script&lang=js&"
export * from "./IndexLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41067d4",
  null
  
)

export default component.exports